var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Planned for today"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008549"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40896",
    x: 23.5,
    y: 33.6016,
    width: 43.4132,
    height: 32.407,
    rx: 6,
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40895",
    d: "M58.7358 36.5474V32.1833C58.7358 24.3501 52.3857 18 44.5525 18V18C36.7192 18 30.3691 24.3501 30.3691 32.1833V36.5474",
    stroke: "#1C1919",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250832",
    d: "M30.8379 52.8557L36.6467 47.0469M36.6467 52.8557L31.1436 47.3526",
    stroke: "#1C1919",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250833",
    d: "M42.1504 52.8557L47.9592 47.0469M47.9592 52.8557L42.4561 47.3526",
    stroke: "#1C1919",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250834",
    d: "M53.7676 52.8557L59.5764 47.0469M59.5764 52.8557L54.0733 47.3526",
    stroke: "#1C1919",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1209",
    d: "M36.0811 8.54698C36.2192 8.30787 36.1374 8.00205 35.8983 7.86392L32.0017 5.61299C31.7626 5.47486 31.4568 5.55672 31.3186 5.79584C31.1805 6.03495 31.2624 6.34076 31.5015 6.47889L34.9651 8.47972L32.9643 11.9433C32.8261 12.1825 32.908 12.4883 33.1471 12.6264C33.3862 12.7645 33.692 12.6827 33.8302 12.4436L36.0811 8.54698ZM35.5189 82.2008C35.7856 82.2722 36.0597 82.1139 36.1311 81.8471C36.2026 81.5804 36.0442 81.3062 35.7774 81.2348L35.5189 82.2008ZM8 45.0073C8 27.6598 19.7797 13.0623 35.7774 8.77987L35.5189 7.81388C19.0949 12.2104 7 27.1958 7 45.0073H8ZM35.7774 81.2348C19.7797 76.9524 8 62.3549 8 45.0073H7C7 62.8189 19.0949 77.8042 35.5189 82.2008L35.7774 81.2348Z",
    fill: "#1C1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1210",
    d: "M55.4809 7.81388C55.2141 7.74247 54.94 7.90083 54.8686 8.16758C54.7972 8.43433 54.9555 8.70846 55.2223 8.77987L55.4809 7.81388ZM54.9186 81.4677C54.7805 81.7068 54.8623 82.0126 55.1015 82.1508L58.998 84.4017C59.2371 84.5398 59.543 84.458 59.6811 84.2188C59.8192 83.9797 59.7374 83.6739 59.4982 83.5358L56.0346 81.535L58.0354 78.0713C58.1736 77.8322 58.0917 77.5264 57.8526 77.3883C57.6135 77.2502 57.3077 77.332 57.1695 77.5711L54.9186 81.4677ZM55.2223 8.77987C71.22 13.0623 82.9997 27.6598 82.9997 45.0073H83.9997C83.9997 27.1958 71.9048 12.2104 55.4809 7.81388L55.2223 8.77987ZM82.9997 45.0073C82.9997 62.3549 71.22 76.9524 55.2223 81.2348L55.4809 82.2008C71.9048 77.8042 83.9997 62.8189 83.9997 45.0073H82.9997Z",
    fill: "#1C1919"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/changePassword.913e0a527f89e305d4034749f760060b.svg";
export { ForwardRef as ReactComponent };